import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();

  const PRIMARY_LIGHT = theme.palette.primary.light;

  const PRIMARY_MAIN = theme.palette.primary.main;

  const PRIMARY_DARK = theme.palette.primary.dark;

  // OR
  // -------------------------------------------------------
  // const logo = (
  //   <Box
  //     component="img"
  //     src="/logo/logo_single.svg" => your path
  //     sx={{ width: 40, height: 40, cursor: 'pointer', ...sx }}
  //   />
  // );

  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 512 512">
        <defs>
          <linearGradient id="BG1" x1="0%" x2="100%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="100%" x2="0%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_MAIN} />
            <stop offset="100%" stopColor={PRIMARY_DARK} />
          </linearGradient>
        </defs>

        {/* Qog'oz varag'i */}
        <rect x="100" y="60" width="280" height="360" rx="24" fill="url(#BG1)" opacity="0.15" />
        <rect x="120" y="80" width="280" height="360" rx="24" fill="url(#BG1)" />

        {/* Qog'ozdagi satrlar */}
        <rect x="168" y="160" width="180" height="12" rx="6" fill={PRIMARY_DARK} opacity="0.3" />
        <rect x="168" y="196" width="150" height="12" rx="6" fill={PRIMARY_DARK} opacity="0.25" />
        <rect x="168" y="232" width="170" height="12" rx="6" fill={PRIMARY_DARK} opacity="0.2" />
        <rect x="168" y="268" width="120" height="12" rx="6" fill={PRIMARY_DARK} opacity="0.15" />

        {/* Qalam */}
        <g transform="translate(310, 280) rotate(-45)">
          <rect x="0" y="0" width="28" height="180" rx="4" fill="url(#BG2)" />
          <polygon points="6,180 22,180 14,210" fill={PRIMARY_DARK} />
          <rect x="0" y="0" width="28" height="24" rx="4" fill={PRIMARY_DARK} opacity="0.4" />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
